import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import { useParams } from "react-router-dom";
import DeviceConnection from "./device-event-history/DeviceConnection";
import DeviceValve from "./device-event-history/DeviceValve";
import DeviceOverPressure from "./device-event-history/DeviceOverpressure";
import deviceEventStore from "../../../stores/DeviceEventStore";

const DeviceEventHistory = () => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Connection History");

  const { pimios_id } = useParams();
  const deviceId = pimios_id?.split("-")[0];
  console.log("DeviceId : ", deviceId);
  const deviceName = pimios_id?.split("-").slice(1).join("-");

  useEffect(() => {
    if (deviceId) {
      deviceEventStore.fetchDeviceEvents(deviceId);
    }
  }, [deviceId]);

  const tab = ["Connection History", "Valve History", "Overpressure History"];
  const tabDescriptions = {
    "Connection History": "View connection event history",
    "Valve History": "Observe valve event history",
    "Overpressure History": "Inspect overpressure event history",
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Connection History":
        return <DeviceConnection />;
      case "Valve History":
        return <DeviceValve />;
      case "Overpressure History":
        return <DeviceOverPressure />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Styled Card Header */}
      <Card
        elevation={3}
        sx={{
          mb: 4,
          p: 2,
          background: "#F3F4F6",
          borderLeft: "4px solid #22C55E",
        }}
      >
        <CardContent>
          <Box display="flex" alignItems="center" mb={1}>
            <DevicesOtherIcon
              fontSize="large"
              sx={{ mr: 2, color: "#22C55E" }}
            />
            <Typography variant="h4" fontWeight="bold">
              {activeTab}
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary">
            {tabDescriptions[activeTab]} for {deviceName}
          </Typography>
        </CardContent>
      </Card>

      {/* Tab Buttons */}
      <Box className="flex gap-2 mb-5">
        {tab.map((tab) => (
          <Box
            key={tab}
            sx={{
              borderBottom: "2px solid",
              borderColor:
                activeTab === tab
                  ? theme.palette.mode === "dark"
                    ? theme.palette.primary.main
                    : "#22C55E"
                  : "transparent",
            }}
          >
            <Button
              onClick={() => setActiveTab(tab)}
              sx={{
                textTransform: "none",
                color:
                  activeTab === tab
                    ? theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : "#000000"
                    : "text.primary",
              }}
            >
              {tab}
            </Button>
          </Box>
        ))}
      </Box>

      {renderActiveTab()}
    </Box>
  );
};

export default DeviceEventHistory;
